import { shareColumnsExtend, shareFormColumnsExtend } from './share';
export const USER_ROLES = [
  'designer',
  'pattern_maker',
  'cheif_pattern_making_officier',
  'merchandiser',
  'salesman',
  'boss',
  'supplier',
  'application_admin_user',
  'sales_director',
  'supplier_boss',
  'craftsman',
  'sewer',
  'valuer',
  'quality_inspector',
  'plate_reviewer',
  'purchaser',
  'guest',
]

export const USER_STATES = [
  'init',
  'pending',
  'approved',
  'rejected',
]

export const USER_PATTERN_FACTORIES = [
  'pattern',
  'cooperative_pattern',
  'semi_finished_pattern',
]

const entityColumns = {
  id: {
    model_name: 'User',
    column_type: 'id',
    label_key_path: 'user.id',
  },
  created_at: {
    model_name: 'User',
    column_type: 'datetime',
    label_key_path: 'user.createdAt',
  },
  updated_at: {
    model_name: 'User',
    column_type: 'datetime',
    label_key_path: 'user.updatedAt',
  },
  is_block: {
    model_name: 'User',
    column_type: 'boolean',
    label_key_path: 'user.isBlock',
  },
  role: {
    model_name: 'User',
    column_type: 'enum',
    extra: {
      options: ['designer', 'pattern_maker', 'cheif_pattern_making_officier', 'merchandiser', 'salesman', 'boss', 'supplier', 'application_admin_user', 'sales_director', 'supplier_boss', 'craftsman', 'sewer', 'valuer', 'quality_inspector', 'plate_reviewer', 'purchaser', 'guest'],
    },
    label_key_path: 'user.role',
  },
  company: {
    model_name: 'User',
    column_type: 'belongs_to',
    label_key_path: 'user.company',
    extra: {
      association_name: 'company',
      model_name: 'Company',
      foreign_key: 'company_id',
      display_column: 'name',
    },
  },
  company_id: {
    model_name: 'User',
    column_type: 'belongs_to',
    label_key_path: 'user.company',
    extra: {
      association_name: 'company',
      model_name: 'Company',
      foreign_key: 'company_id',
      display_column: 'name',
    },
  },
  remark: {
    model_name: 'User',
    column_type: 'string',
    label_key_path: 'user.remark',
  },
  screen_name: {
    model_name: 'User',
    column_type: 'string',
    label_key_path: 'user.screenName',
  },
  state: {
    model_name: 'User',
    column_type: 'enum',
    extra: {
      options: ['init', 'pending', 'approved', 'rejected'],
    },
    label_key_path: 'user.state',
  },
  reject_reason: {
    model_name: 'User',
    column_type: 'string',
    label_key_path: 'user.rejectReason',
  },
  sales_director: {
    model_name: 'User',
    column_type: 'belongs_to',
    label_key_path: 'user.salesDirector',
    extra: {
      association_name: 'sales_director',
      model_name: 'User',
      foreign_key: 'sales_director_id',
      display_column: 'screen_name',
    },
  },
  sales_director_id: {
    model_name: 'User',
    column_type: 'belongs_to',
    label_key_path: 'user.salesDirector',
    extra: {
      association_name: 'sales_director',
      model_name: 'User',
      foreign_key: 'sales_director_id',
      display_column: 'screen_name',
    },
  },
  expires_at: {
    model_name: 'User',
    column_type: 'datetime',
    label_key_path: 'user.expiresAt',
  },
  profile: {
    model_name: 'User',
    column_type: 'string',
    label_key_path: 'user.profile',
  },
  update_product_cost_price: {
    model_name: 'User',
    column_type: 'boolean',
    label_key_path: 'user.updateProductCostPrice',
  },
  product_operator: {
    model_name: 'User',
    column_type: 'boolean',
    label_key_path: 'user.productOperator',
  },
  manage_other_product_design: {
    model_name: 'User',
    column_type: 'boolean',
    label_key_path: 'user.manageOtherProductDesign',
  },
  manage_other_product_design_files: {
    model_name: 'User',
    column_type: 'boolean',
    label_key_path: 'user.manageOtherProductDesignFiles',
  },
  read_other_product_design_cost: {
    model_name: 'User',
    column_type: 'boolean',
    label_key_path: 'user.readOtherProductDesignCost',
  },
  read_product_design_statistics: {
    model_name: 'User',
    column_type: 'boolean',
    label_key_path: 'user.readProductDesignStatistics',
  },
  read_order_cost: {
    model_name: 'User',
    column_type: 'boolean',
    label_key_path: 'user.readOrderCost',
  },
  read_product_cost_price: {
    model_name: 'User',
    column_type: 'boolean',
    label_key_path: 'user.readProductCostPrice',
  },
  read_company: {
    model_name: 'User',
    column_type: 'boolean',
    label_key_path: 'user.readCompany',
  },
  read_production_orders: {
    model_name: 'User',
    column_type: 'boolean',
    label_key_path: 'user.readProductionOrders',
  },
  avatar: {
    model_name: 'User',
    column_type: 'attached',
    extra: {
      size: 20,
    },
    label_key_path: 'user.avatar',
  },
  avatar_with_audio: {
    model_name: 'User',
    prop: 'avatar_attachment',
    label_key_path: 'user.avatarAttachment',
    column_type: 'attached',
    extra: {
      accept: 'audio/mp3, audio/aac',
      type: 'audio',
      size: 20,
    },
  },
  admin_user: {
    model_name: 'User',
    column_type: 'string',
    label_key_path: 'user.adminUser',
  },
  pattern_factory: {
    model_name: 'User',
    column_type: 'enum',
    extra: {
      options: ['pattern', 'cooperative_pattern', 'semi_finished_pattern'],
    },
    label_key_path: 'user.patternFactory',
  },
  projects: {
    model_name: 'User',
    column_type: 'has_many',
    label_key_path: 'user.projects',
    extra: {
      association_name: 'projects',
      model_name: 'Project',
      foreign_key: 'project_id',
      display_column: 'name',
    },
  },
  project_ids: {
    model_name: 'User',
    column_type: 'has_many',
    label_key_path: 'user.projects',
    extra: {
      association_name: 'projects',
      model_name: 'Project',
      foreign_key: 'project_id',
      display_column: 'name',
    },
  },
  abilities: {
    model_name: 'User',
    column_type: 'string',
    label_key_path: 'user.abilities',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(entityColumns, columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(entityColumns, columns, { formColumnsConfig, type, data })
}
